import { ref, watch, onMounted } from "@vue/composition-api"
import useRouter from "../useRouter"
import _ from "lodash"

const useShopsFilters = () => {

    const {route, router} = useRouter()

    const intialState = {
        alexaRankOrder: null,
        category: [],
        monthlySales: []
    }

    const filters = ref({...intialState})

    watch(route, route => {
        if(route.query.filters) {
            filters.value = {
                ...intialState,
                ...JSON.parse(route.query.filters)
            }
        } else {
            filters.value = ({...intialState})
        }
    }, {immediate: true})

    const setFilter = (key, value) => {

        const filtersObj = {
            ...filters.value,
            [key]: value
        }

        const urlFilters = {}

        for(let key in filtersObj) {
            if(filtersObj[key] === null) {
                continue
            }

            if(Array.isArray(filtersObj[key]) && !filtersObj[key].length){
                continue
            }

            urlFilters[key] = filtersObj[key]
            
        }

        router.replace({
            query: {
                ...route.value.query,
                filters: _.isEmpty(urlFilters) ? undefined : JSON.stringify(urlFilters)
            }
        }).catch(() => {})
    }

    const resetFilters = () => {
        router.replace({
            query: {
                ...route.value.query,
                filters: undefined
            }
        }).catch(() => {})
    }

    return {
        filters,
        setFilter,
        resetFilters
    }
}

export default useShopsFilters